import { XLAYERTESTNET } from '../types';
export default {
  type: XLAYERTESTNET,
  service: 'okx.com-ws',
  url: 'wss://xlayertestws.okx.com',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
